// extracted by mini-css-extract-plugin
export default {"toggleMobile":"ThemeToggle_toggleMobile__SxPmf"};